/* eslint-disable react/no-children-prop */
/**
 * Shows a simple text popup tip on hover
 */
import React from 'react';

import { Tooltip as AntdTooltip } from 'antd';

const Tooltip = ({ title, children }) => (
    <AntdTooltip title={title} children={children} overlayStyle={{ fontFamily: 'inherit' }} />
);

export default Tooltip;
